import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import urlStrings from '../../utils/urlStrings'
import { getSessionToken } from '../../utils/helper'
import BasicApplicationDetails from '../BasicApplicationDetails'
import SiteApplicationDetails from '../SiteApplicationDetails'
import SiteDetails from '../SiteDetails'
import {applicationService} from '../../Services/ApplicationService'
import { useStyles } from './styles'
import history from '../../routes/history'
const ApplicationDetails = (props) => {
  const classes = useStyles()
  const { currentSiteID, setLoading, getSites, status } = props
  const [site, setSite] = useState('')
  useEffect( () => {

    if (currentSiteID) {
      setLoading(true)
      applicationService.getApplicationBySiteId(currentSiteID)
        .then((data) => {
          setSite(data)
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false)
        })
    }
  }, [currentSiteID])

  return (
    <div className={classes.layout}>
      {currentSiteID ? (
        status === 'rejected' && site?.status === 'submitted' ? (
          <BasicApplicationDetails displayText=" Application's status has changed. Please refresh the page."></BasicApplicationDetails>
        ) : (
          <SiteApplicationDetails
            getSites={getSites}
            setLoading={setLoading}
            site={site}
          ></SiteApplicationDetails>

          // <BasicApplicationDetails displayText=" Application's status has changed. Please refresh the page."></BasicApplicationDetails>
        )
      ) : (
        <BasicApplicationDetails displayText="Click on the Site ID from the left pane to open the application"></BasicApplicationDetails>
      )}
    </div>
  )
}
const mapStateToProps = ({ applications }) => {
  const { currentSiteID } = applications
  return { currentSiteID }
}

export default connect(mapStateToProps, null)(ApplicationDetails)
